import React from 'react';
import './Error404.css'
import NavDock from '../Components/Layout/NavDock';

import Curve from '../Assets/Icons/Curve.svg'
import ErrorImg from '../Assets/Imgs/ErrorImg.png'
import Btn from '../Components/Common/Btn';


const Error404 = () => {
    return ( 
        <main className='Error'>
            <div className='TopBar'></div>
            <div className='ErrorMain'>
                <img src={ErrorImg} alt="" />
                <p className='ErrorTitle'>
                    The page you’re trying to visit isn’t available right now
                </p>
                <p className='ErrorSub'>
                    Please check back Later
                </p>

                <Btn BtnText="Go Back" BtnPath='/home' BtnStyle='GreenBtn'/>
            </div>
            <NavDock Curve={Curve} NotchClass='NotchCurve'/>
        </main>
     );
}
 
export default Error404;